import React from "react";
import { ShopifyProvider } from "@shopify/hydrogen-react";
import { shopifyConst } from "@/hooks/shopify-hooks/useShopifyConst";

function Provider(props) {
  const {
    storefrontAccessToken,
    domain,
    ApiVersion,
    countryIsoCode,
    languageIsoCode,
  } = shopifyConst;
  // 配置缺失
  if (!storefrontAccessToken || !domain || !ApiVersion || !countryIsoCode || !languageIsoCode) {
    throw new Error('Shopify Provider 配置不完整');
  }
  return (
    <ShopifyProvider
      storeDomain={domain}
      storefrontToken={storefrontAccessToken}
      storefrontApiVersion={ApiVersion}
      countryIsoCode={countryIsoCode}
      languageIsoCode={languageIsoCode}
    >
        {props.children}
    </ShopifyProvider>
  );
}

export default Provider;
